





















import Vue from 'vue'
import Nav from './components/Nav/index.vue'
import Footer from './components/Footer/index.vue'
import Sidebar from './components/Sidebar/index.vue'
import PopUp from './components/PopUp/index.vue'

import { UserStore } from '@/store/modules/User'

export default Vue.extend({
  components: {
    Nav,
    Sidebar,
    Footer,
    PopUp
  },
  computed: {
    userInfo () {
      return UserStore.userInfo
    }
  }
  // mounted () {
  //   console.log(this.$route)
  //   console.log(router.currentRoute.fullPath)
  // }
})
